import { ComponentPropsWithoutRef } from 'react';

import { InfoOutline } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const FieldHelperText = ({
  children,
  ...props
}: ComponentPropsWithoutRef<'div'>) => (
  <Box
    component="span"
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    }}
    {...props}
  >
    <InfoOutline sx={{ width: 14, height: 14 }} />
    <Typography variant="caption">{children}</Typography>
  </Box>
);
